import { render, staticRenderFns } from "./Copiar.vue?vue&type=template&id=6be1fb46&scoped=true&"
import script from "./Copiar.vue?vue&type=script&lang=js&"
export * from "./Copiar.vue?vue&type=script&lang=js&"
import style0 from "./Copiar.vue?vue&type=style&index=0&id=6be1fb46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be1fb46",
  null
  
)

export default component.exports